import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input, OnChanges, OnDestroy,
  OnInit,
  Output, SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {DxFormComponent, DxTabPanelComponent} from 'devextreme-angular';
import {dxDataGridColumn} from 'devextreme/ui/data_grid';
import {DxPopupComponent} from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
import notify from 'devextreme/ui/notify';
import ValidationEngine from 'devextreme/ui/validation_engine';
import {StatusCodes} from 'http-status-codes';
import {BehaviorSubject, forkJoin, Subject} from 'rxjs';
import {take, takeUntil, tap} from 'rxjs/operators';
import {PhysicianService} from 'src/app/modules/shared/services/physician.service';
import {RegistrationRequest, Role, User} from 'src/app/shared/models/fusion-auth';
import {environment} from 'src/environments/environment';
import {Client} from '../../../../modules/shared/models/order-entry/client';
import {Patient} from '../../../../modules/shared/models/order-entry/patient';
import {Physician} from '../../../../modules/shared/models/order-entry/physician';
import {ClientService, PatientService} from '../../../../modules/shared/services';
import {FusionAuthManagementService, FusionAuthService} from '../../../../shared/services/fusion-auth';
import {ScreenService} from '../../../../shared/services/general';
import {TitleClickEvent} from "devextreme/ui/tab_panel";
import DevExpress from "devextreme";
import ReadyEvent = DevExpress.ui.dxMap.ReadyEvent;
import {ValueChangedEvent} from "devextreme/ui/select_box";

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.scss'],
})
export class UserFormComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @ViewChild(DxPopupComponent, {static: false}) public dialog?: DxPopupComponent;
  @ViewChild('form', {static: false}) public form?: DxFormComponent;
  @ViewChild('tab', {static: false}) public tab?: DxTabPanelComponent;
  @Input() public formVisible = false;
  @Input() public user?: User & {
    role: string;
    data: { clients: number[]; patients: number[]; physicians: number[] };
  } = {} as User & {
    role: string;
    data: { clients: number[]; patients: number[]; physicians: number[] };
  };
  @Input() public roles?: BehaviorSubject<Role[]>;
  @Input() public existentUsers: any = [];
  public selectorRoles?: Role[] = [];
  @Output() public formSubmitted = new EventEmitter<any>();
  public isLoading = false;
  public isBackgroundLoading = false;
  public clients: BehaviorSubject<DataSource> = new BehaviorSubject<DataSource>(null as unknown as DataSource);
  public patients: BehaviorSubject<DataSource> = new BehaviorSubject<DataSource>(null as unknown as DataSource);
  public physicians: BehaviorSubject<DataSource> = new BehaviorSubject<DataSource>(null as unknown as DataSource);
  public clientsOnlyForEdit?: Client[];
  public patientsOnlyForEdit?: Patient[];
  public physiciansOnlyForEdit?: Physician[];
  public lastClientsSelected?: Client[];
  public lastPatientsSelected?: Patient[];
  public lastPhysiciansSelected?: Physician[];

  public clientsGlassDropDownColumns?: dxDataGridColumn[];
  public clientsGlassGridColumns?: dxDataGridColumn[];
  public patientsGlassDropDownColumns?: dxDataGridColumn[];
  public patientsGlassGridColumns?: dxDataGridColumn[];
  public physiciansGlassDropDownColumns?: dxDataGridColumn[];
  public physiciansGlassGridColumns?: dxDataGridColumn[];

  public emailControl?: any;
  //public saveBtn: DxButton;
  public isPhone: boolean = false;
  public isPhoneLandscape: boolean = false;
  public tabIndex = 0;
  public lastTabIndex = 0;
  public onDestroy$: Subject<void> = new Subject<void>();
  public authenticatedUser: any;
  public authenticatedRole: any;

  public physicianDisplayExp = (item: any) => item && `${item.firstName} ${item.lastName}`;
  public patientDisplayExp = (item: any) => item && `${item.firstName} ${item.lastName}`;

  constructor(
    private clientService: ClientService,
    private patientService: PatientService,
    private physicianService: PhysicianService,
    private fusionAuthManagement: FusionAuthManagementService,
    private fusionAuth: FusionAuthService,
    private screen: ScreenService,
  ) {
    /*this.saveBtn = {
        text: 'Save',
        useSubmitBehavior: true,
    };*/
    this.initClientsGlass();
    this.initPatientsGlass();
    this.initPhysiciansGlass();

    this.roleChanged = this.roleChanged.bind(this);
    this.onTabSelectionChange = this.onTabSelectionChange.bind(this);
    this.ready = this.ready.bind(this);
    this.onContentReady = this.onContentReady.bind(this);
  }

  private initClientsGlass() {
    this.clientsGlassDropDownColumns = [
      {
        caption: 'Code',
        dataField: 'code',
        width: '80',
        hidingPriority: 0,
      } as dxDataGridColumn,
      {
        caption: 'Name',
        dataField: 'name',
      } as dxDataGridColumn,
    ];

    this.clientsGlassGridColumns = [
      {
        caption: 'Code',
        dataField: 'code',
        width: '80',
        hidingPriority: 0,
      } as dxDataGridColumn,
      {
        caption: 'Name',
        dataField: 'name',
      } as dxDataGridColumn
    ];
  }

  private initPhysiciansGlass() {
    this.physiciansGlassDropDownColumns = [
      {
        caption: 'NPI',
        dataField: 'npi',
        width: '80',
        hidingPriority: 0,
      } as dxDataGridColumn,
      {
        caption: 'Last Name',
        dataField: 'lastName',
      } as dxDataGridColumn,
      {
        caption: 'First Name',
        dataField: 'firstName',
      } as dxDataGridColumn
    ];

    this.physiciansGlassGridColumns = [
      {
        caption: 'NPI',
        dataField: 'npi',
        width: '80',
        hidingPriority: 0,
      } as dxDataGridColumn,
      {
        caption: 'Last Name',
        dataField: 'lastName',
      } as dxDataGridColumn,
      {
        caption: 'First Name',
        dataField: 'firstName',
      } as dxDataGridColumn,
    ];
  }

  private initPatientsGlass() {
    this.patientsGlassDropDownColumns = [
      {
        caption: 'Last Name',
        dataField: 'lastName',
      } as dxDataGridColumn,
      {
        caption: 'First Name',
        dataField: 'firstName',
      } as dxDataGridColumn,
      {
        caption: 'Birth Date',
        dataField: 'birthDate',
        dataType: 'date',
        hidingPriority: 0,
      } as dxDataGridColumn,
    ];

    this.patientsGlassGridColumns = [
      {
        caption: 'Code',
        dataField: 'code',
        width: '80',
        hidingPriority: 0,
      } as dxDataGridColumn,
      {
        caption: 'Last Name',
        dataField: 'lastName',
      } as dxDataGridColumn,
      {
        caption: 'First Name',
        dataField: 'firstName',
      } as dxDataGridColumn,
      {
        caption: 'Birth Date',
        dataField: 'birthDate',
        dataType: 'date',
        hidingPriority: 1,
      } as dxDataGridColumn
    ];
  }

  public activeTab(): string {
    let tab = '';
    const roleIndex = this.roles?.value.findIndex(r => r.name === this.user?.role);

    if (roleIndex !== undefined && roleIndex !== -1) {
      if (this.roles?.value[roleIndex].name.toLocaleLowerCase().includes('client')) {
        tab = 'client';
      }
      if (this.roles?.value[roleIndex].name.toLocaleLowerCase().includes('patient')) {
        tab = 'patient';
      }
      if (this.roles?.value[roleIndex].name.toLocaleLowerCase().includes('physician')) {
        tab = 'physician';
      }
    }

    return tab;
  }

  public onTabSelectionChange(e: TitleClickEvent) {
    //this.lastTabIndex = e.itemIndex;
    if (e.itemData.title === 'Clients' || e.itemData.title === 'Patients' || e.itemData.title === 'Physicians') {
      this.isLoading = this.isBackgroundLoading;
    } else {
      this.isLoading = false;
    }
  }

  public onContentReady() {
    if (this.lastClientsSelected && this.lastClientsSelected.length > 0) {
      this.clientsOnlyForEdit = this.lastClientsSelected;
    }
    if (this.lastPhysiciansSelected && this.lastPhysiciansSelected.length > 0) {
      this.physiciansOnlyForEdit = this.lastPhysiciansSelected;
    }
    if (this.lastPatientsSelected && this.lastPatientsSelected.length > 0) {
      this.patientsOnlyForEdit = this.lastPatientsSelected;
    }
  }

  public ngOnInit() {
    this.isBackgroundLoading = true;
    if (this.user === undefined) {
      this.user = {role: [], data: {}, active: true} as any;
    }

    this.isPhone = this.screen.sizes['screen-x-small'];
    this.isPhoneLandscape = this.screen.sizes['screen-small'];
    this.screen.changed.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
      this.isPhone = this.screen.sizes['screen-x-small'];
      this.isPhoneLandscape = this.screen.sizes['screen-small'];
      if (this.tab) {
        this.tabIndex = this.lastTabIndex;
      }
    });

    this.waitByUser();
  }

  public waitByUser() {
    this.authenticatedUser = this.fusionAuth.Profile;
    if (this.authenticatedUser) {
      this.authenticatedRole = this.authenticatedUser ? this.authenticatedUser.registrations[0].roles[0] : '';

      if (this.authenticatedRole === 'Client Admin') {
        this.physicians.next(new DataSource({store: this.physicianService.customStoreByClientsIds(this.authenticatedUser.data.clients, this.physicians)}));
        this.clients.next(new DataSource({store: this.clientService.customStoreFilteredByClientIds(this.authenticatedUser.data.clients, this.clients)}));
        this.patients.next(new DataSource({store: this.patientService.store(this.authenticatedUser.data.clients, this.patients)}));
      } else {
        this.physicians.next(new DataSource({store: this.physicianService.customStoreByClientsIds([], this.physicians)}));
        this.clients.next(new DataSource({store: this.clientService.store(this.clients)}));
        this.patients.next(new DataSource({store: this.patientService.store([], this.patients)}));
      }

      this.isBackgroundLoading = false;
      this.isLoading = false;
    } else {
      setTimeout(() => {
        this.waitByUser();
      }, 1000);
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    /*if (changes.formVisible && changes.formVisible.currentValue) {
      of(null)
        .pipe(debounceTime(500), take(1))
        .subscribe(() => {
          if (this.emailControl) {
            this.emailControl.instance().focus();
          }
        });
    }*/

    if (changes.formVisible && changes.formVisible.currentValue && this.user !== undefined) {
      this.isBackgroundLoading = true;
      //TODO FIX THIS
      forkJoin(this.clientService.getClientsByIds(this.user.data.clients),
        this.physicianService.getByIds(this.user.data.physicians),
        this.patientService.getByIds(this.user.data.patients),
      )
        .pipe(take(1))
        .subscribe({
          next: value => {
            this.clientsOnlyForEdit = value[0];
            this.physiciansOnlyForEdit = value[1];
            this.patientsOnlyForEdit = value[2];
          },

          complete: () => {
            this.isBackgroundLoading = false;
            this.isLoading = false;
          },
        });
    }
  }

  public ready(e: ReadyEvent) {
    this.emailControl = e.component;
  }

  public roleChanged(event: ValueChangedEvent) {
    if (this.user) {
      this.user.role = event.value;
      if (this.user.registrations) {
        this.user.registrations
          .filter(r => r.applicationId === environment.fusionAuth.applicationId)
          .forEach(r => r.roles = [event.value]);
      }
    }
  }

  public clear() {
    this.user = {role: [], data: {}, active: true} as any;
  }

  public close() {
    this.clear();
    this.clearDataSelected();
    this.formSubmitted.next();
  }

  private clearDataSelected() {
    this.lastClientsSelected = [];
    this.lastPatientsSelected = [];
    this.lastPhysiciansSelected = [];
    setTimeout(() => {
      this.form?.instance.resetValues();
      ValidationEngine.resetGroup('userData');
    }, 1500);
  }

  public submit(event: any): void {
    event.preventDefault();

    const formResult = ValidationEngine.validateGroup('userData');
    const clientSelected = (this.user?.role === 'Client Basic' || this.user?.role === 'Client Admin') &&
      (!this.user.data || !this.user.data.clients || this.user.data.clients.length === 0);
    const patientSelected = this.user?.role === 'Patient' && (!this.user.data || !this.user.data.patients || this.user.data.patients.length === 0);
    const physicianSelected = this.user?.role === 'Physician' && (!this.user.data || !this.user.data.physicians || this.user.data.physicians.length === 0);

    if (!formResult.isValid || clientSelected || patientSelected || physicianSelected) {
      if (clientSelected) {
        this.notifyError('Please select a client');
      } else if (patientSelected) {
        this.notifyError('Please select a patient');
      } else if (physicianSelected) {
        this.notifyError('Please select a physician');
      }
      return;
    }

    if (this.user?.id) {
      this.createOrUpdateUser();
    } else {
      this.fusionAuthManagement.existUser(this.user?.email as string).pipe(take(1)).subscribe(result => {
        if (result) {
          this.notifyError('Email in use');
        } else {
          this.createOrUpdateUser();
        }
      });
    }
  }

  private createOrUpdateUser() {
    if (!this.user) return;
    const username = this.user.id ? this.user?.username : this.user.email.split('@')[0] + (Math.floor(Math.random() * (99999 - 10000)) + 10000);
    this.user.username = username;

    switch (this.user.role) {
      case 'Patient':
        this.user.data = {...this.user.data, clients: [], patients: this.user.data.patients, physicians: []};
        break;
      case 'Physician':
        this.user.data = {...this.user.data, clients: [], patients: [], physicians: this.user.data.physicians};
        break;
      case 'Superuser':
        this.user.data = {...this.user.data, clients: [], patients: [], physicians: []};
        break;
      default:
        this.user.data = {...this.user.data, clients: this.user.data.clients, patients: [], physicians: []};
        break;
    }

    const request: RegistrationRequest = {
      user: this.user,
      registration: {
        applicationId: environment.fusionAuth.applicationId,
        roles: [this.user.role],
        username,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
    };

    this.isLoading = true;
    if (this.user.id) {
      this.fusionAuthManagement
        .updateUser(this.user.id, request)
        .pipe(tap(() => (this.isLoading = !this.isLoading)))
        .pipe(take(1))
        .subscribe(response => {
          if (response.status === StatusCodes.CREATED) {
            notify('User has been updated.', 'success');
            this.clearDataSelected();
            this.formSubmitted.emit(response.body);
          }
        });
    } else {
      this.fusionAuthManagement
        .createUser(request)
        .pipe(tap(() => (this.isLoading = !this.isLoading)))
        .pipe(take(1))
        .subscribe(response => {
          if (response.status === StatusCodes.CREATED) {
            notify('A notification has been sent to created user\'s email.', 'success');
            this.clearDataSelected();
            this.formSubmitted.emit(response.body);
          }
        });
    }
  }

  private notifyError(message: string): void {
    notify({
      message,
      width: 400,
      position: {
        my: 'bottom center',
        at: 'bottom center',
        of: '#toast',
        offset: '0 0',
      },
    }, 'error', 1000);
  }

  public clientsGlassChanged(selectedClients: Client[]) {
    if(!this.user) return;
    this.lastClientsSelected = selectedClients;
    this.user.data.clients = selectedClients.map(c => c.id);
  }

  public patientsGlassChanged(selectedPatients: Patient[]) {
    if(!this.user) return;
    this.lastPatientsSelected = selectedPatients;
    this.user.data.patients = selectedPatients.map(p => p.id);
  }

  public physiciansGlassChanged(selectedPhysicians: Physician[]) {
    if(!this.user) return;
    this.lastPhysiciansSelected = selectedPhysicians;
    this.user.data.physicians = selectedPhysicians.map(p => p.id);
  }

  public ngAfterViewInit(): void {
    this.roles?.pipe(take(1)).subscribe(roles => {
      switch (this.fusionAuth.Profile.role) {
        case 'Client Admin':
          this.selectorRoles?.push(
            ...roles.filter(
              r => r.name === 'Patient' ||
                r.name === 'Client Basic',
            ),
          );
          break;
        case 'Superuser':
          this.selectorRoles?.push(...roles);
          break;
      }
    });
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
